import Vue from "vue";
import GmapVue from "gmap-vue";

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyCZdXgcDnQXJyx7JAqxaUE9mqTWvZJFZug",
  },
  installComponents: true,
});
